import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addDocumentSet: {
    id: 'app.containers.WorkflowEditor.components.Rules.DocumentSigningRules.addDocumentSet',
    defaultMessage: 'Add Document Set',
  },
});
